import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicRoutesService } from 'src/app/services/dynamic-routes.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dynamic-routes',
  templateUrl: './dynamic-routes.component.html',
  styleUrls: ['./dynamic-routes.component.scss']
})
export class DynamicRoutesComponent implements OnInit {

  search = '';
  token = ''
  breadcrumbs = []
  ProcedureValue:any = {}
  pathPatterns: any[];
  displayedColumnsPathPattern = ["Id","Nombre","Tipo de Patron","Plataformas de Conferencias","actions"]
  pathPatternsSections: any[] = [];
  displayedColumnsPathPatternSections = ["Tipo de Sección","Es editable","Sección del patrón","actions"]

  isPathPatternSections: boolean = false;

  pathPatternId: string;
  user_id: string;


  constructor(private activeRoute: ActivatedRoute,private router: Router,private dynamic: DynamicRoutesService) { }

  ngOnInit(): void {
    this.token = localStorage.getItem( 'token')
    this.user_id = localStorage.getItem('user_id');
    if(this.user_id != null)
    {
      this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))

      this.activeRoute.params.subscribe(params => {

        let formT = localStorage.getItem('formTransliterator')
        if (formT == null){
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Rutas dinámicas', url: '/routes'},
          ]
        }

      })
      this.activeRoute.paramMap.subscribe(params => {
        if(params.get('PathPatternId')){
          this.pathPatternId = params.get('PathPatternId');
          this.getPathPatternSectionsByPathPatternId();
        }
      });
    }
    else this.exit()

    this.dynamic.getPathPatterns().subscribe(
      result => {
        this.pathPatterns = result;
      },
      error => console.error('Error:', error)
    );

  }

  exit(): void{
    this.router.navigate(['/']);
  }

  back(){
    this.router.navigate([`routes`])
    this.isPathPatternSections = false;
  }

  onRowClick(pathPatternId: number): void {
    this.pathPatternId = pathPatternId.toString();
    this.getPathPatternSectionsByPathPatternId();
  }

  getPathPatternSectionsByPathPatternId(){
    this.dynamic.getPathPatternSectionsByPathPatternId(this.pathPatternId.toString()).subscribe(
      result => {
        this.pathPatternsSections = result;
        this.isPathPatternSections = true;
      },
      error => console.error('Error:', error)
    );
  }

}
